module.exports = __webpack_public_path__ + "static/media/group.js.3bd21978.map";